import React from 'react';
import { HeartFilled } from '@ant-design/icons';
import { useT } from '../../../common/i18n';
import './footer.scss';

const Footer = () => {
    const t = useT();
    const year = new Date().getFullYear();

    return (
        <footer className="app-footer" role="contentinfo">
            <div className="app-footer-bottom">
                <div className="app-footer-bottom-inner">
                    <div className="footer-copy">
                        © {year} <strong>Cap Assurances</strong>
                        <span className="footer-copy-sep">•</span>
                        <span className="footer-copy-rights">Tous droits réservés</span>
                    </div>
                    <div className="footer-made">
                        <span>{t('footer.made_with') || 'Fait avec'}</span>
                        <HeartFilled className="footer-heart" aria-hidden />
                        <span>{t('footer.in_ci') || "en Côte d'Ivoire"}</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
